export const GET_CONFIGS = "GET_CONFIGS"
export const GET_CONFIGS_SUCCESS = "GET_CONFIGS_SUCCESS"
export const GET_CONFIGS_ERROR = "GET_CONFIGS_ERROR"
